import isBoolean from 'lodash/isBoolean';
import { APS_BIDS_FETCH_ERROR } from '../../logging/constants';
import logger from '../../logging/logger';
import { State, getState, updateState } from '../../utils/applicationState';
import { getExperiment } from '../../utils/getExperiment';
import { VIDEO_MEDIUM } from '../constants';
import Events from '../media/Events';
import mediaEvents from '../media/mediaEvents';
const ONE_MINUTE_IN_MILLISECONDS = 60_000;
const uamNetworkController = {
    apsParamsIntervalId: null,
    init() {
        const isInDiscordIFrame = getState(State.isInDiscordIFrame);
        !((a9, a, p, s, t, A, g) => {
            if (a[a9]) {
                return;
            }
            function q(c, r) {
                a[a9]._Q.push([c, r]);
            }
            a[a9] = {
                init() {
                    q('i', arguments);
                },
                fetchBids() {
                    q('f', arguments);
                },
                setDisplayBids() { },
                targetingKeys() {
                    return [];
                },
                _Q: [],
            };
            A = p.createElement(s);
            A.async = !0;
            A.src = t;
            g = p.getElementsByTagName(s)[0];
            g.parentNode.insertBefore(A, g);
        })('apstag', window, document, 'script', isInDiscordIFrame
            ? '/amazon/aps/aax2/apstag.js'
            : '//c.amazon-adsystem.com/aax2/apstag.js');
        if (window.apstag) {
            const ccpaData = getState(State.ccpaData, {});
            const { gdprApplies, tcString } = getState(State.gdprData);
            const params = {
                us_privacy: ccpaData.usPrivacyString,
            };
            if (isBoolean(gdprApplies)) {
                params.gdpr = gdprApplies ? 1 : 0;
            }
            if (tcString) {
                params.gdpr_consent = tcString;
            }
            window.apstag.init({
                pubID: '3111b792-be07-4cd2-bd99-c42ac9a74f71',
                adServer: 'googletag',
                videoAdServer: 'DFP',
                params,
            });
        }
    },
    fetchBids(slot) {
        return new Promise((resolve) => {
            apstag.fetchBids({
                slots: [slot],
                timeout: 2e3,
            }, resolve);
        });
    },
    async fetchAndStoreApsParamsWithInterval(mediaType, slot) {
        if (this.apsParamsIntervalId) {
            clearInterval(this.apsParamsIntervalId);
        }
        await this.fetchAndStoreApsParams(mediaType, slot);
        this.apsParamsIntervalId = setInterval(() => this.fetchAndStoreApsParams(mediaType, slot), getExperiment('ads.video.preroll.newFlow.tam.refreshTimeout.minutes', 60) * ONE_MINUTE_IN_MILLISECONDS);
    },
    setApsBidsRequestHasFinished() {
        if (getState(State.isApsBidsRequestFinished)) {
            return;
        }
        updateState(State.isApsBidsRequestFinished, true);
    },
    async fetchAndStoreApsParams(mediaType, slot = {}) {
        try {
            setTimeout(this.setApsBidsRequestHasFinished, getExperiment('ads.video.preroll.newFlow.tam.timeoutMs', 3000));
            const apsBids = await this.fetchBids(mediaType === VIDEO_MEDIUM
                ? {
                    slotID: 'APS_VideoINT_GAM',
                    mediaType,
                }
                : slot);
            if (mediaType === VIDEO_MEDIUM) {
                updateState(State.videoApsCustParams, this.transformApsVideoBids(mediaType, apsBids));
                if (!apsBids?.some((bid) => bid.mediaType === mediaType)) {
                    mediaEvents
                        .event(Events.Type.audioVideoAd, Events.Status.amazonKeywordsRequestFailed)
                        .emit({
                        errorCode: Events.AmazonKeywordsErrorCodes.EMPTY_PARAMS,
                        errorDescription: Events.AmazonKeywordsErrorDescriptions.EMPTY_PARAMS,
                    });
                }
            }
            logger.debug('The APS bids request is resolved successfully.');
        }
        catch (ex) {
            if (mediaType === VIDEO_MEDIUM) {
                mediaEvents
                    .event(Events.Type.audioVideoAd, Events.Status.amazonKeywordsRequestFailed)
                    .emit({
                    errorCode: Events.AmazonKeywordsErrorCodes.REQUEST_FAILED,
                    errorDescription: Events.AmazonKeywordsErrorDescriptions.REQUEST_FAILED,
                });
            }
            logger.debug('The APS bids request is failed.', ex);
            logger.error({
                message: APS_BIDS_FETCH_ERROR,
                error: ex,
            });
        }
        this.setApsBidsRequestHasFinished();
    },
    transformApsVideoBids(mediaType, bids = []) {
        return bids
            .filter((bid) => bid.mediaType === mediaType)
            .map((bid) => bid.qsParams || bid.encodedQsParams || bid.helpers.encodedQsParams())
            .join('');
    },
};
export default uamNetworkController;
